export default "__VITE_ASSET__d00cff7c__"